import { Component, EventEmitter, Input, Output } from '@angular/core';

import {
  getFileContentType,
  getFileExtension,
  getFileForPreview,
  getFileName,
} from '../../../utils/file.util';
import { UploadedFile } from '../multi-file-upload.component';
import { MultiFileUploadService } from '../multi-file-upload.service';

@Component({
  selector: 'lib-uploaded-file-preview',
  templateUrl: './uploaded-file-preview.component.html',
  styleUrl: './uploaded-file-preview.component.scss',
  standalone: false,
})
export class UploadedFilePreviewComponent {
  @Input() public files: UploadedFile[] = [];
  @Input() public highlightRemovableFiles = false;
  @Input() public readOnly = false;
  @Input() public showLargePreview = false; // NEW: Flag to show large preview
  @Output() public handleDeleteFileEvent = new EventEmitter<UploadedFile>();

  public showPreview = true; // Control whether to show actual preview or just icons

  constructor(
    private readonly _multiFileUploadService: MultiFileUploadService
  ) {}

  protected removeFile(index: number): void {
    const fileToRemove = this.files[index];
    if (!fileToRemove) {
      return;
    }
    this.handleDeleteFileEvent.emit(fileToRemove);
  }

  /**
   * Determine if the file is an image (excluding SVGs)
   */
  protected isImage(file: UploadedFile): boolean {
    const contentType = getFileContentType(file);
    return (
      contentType.startsWith('image/') && !contentType.startsWith('image/svg')
    );
  }

  protected isVideo(file: UploadedFile): boolean {
    const contentType = getFileContentType(file);
    return contentType.startsWith('video/');
  }

  /**
   * Use shared utils for file info
   */
  protected getFileForPreview(file: UploadedFile): File | undefined {
    return getFileForPreview(file);
  }

  protected getFileName(file: UploadedFile): string {
    return getFileName(file);
  }

  protected getFileExtension(file: UploadedFile): string {
    return getFileExtension(file);
  }

  protected getFileContentType(file: UploadedFile): string {
    return getFileContentType(file);
  }

  /**
   * Format file size in human readable format
   */
  protected formatFileSize(bytes: number): string {
    return this._multiFileUploadService.formatFileSize(bytes);
  }
}
